import { ApiError } from '../errors/api-error.js';

export class DelegationService {
    constructor(api) { this.api = api; }

    async getAll(p = {}) { return this._wrap(() => this.api.getAll(p), 'Failed to list delegations'); }
    async mine() { return this._wrap(() => this.api.mine(), 'Failed to list my delegations'); }
    async toMe() {
        try {
            const r = await this.api.toMe();
            return {
                success: true,
                data: r?.data ?? r,
                actingPrincipalIds: Array.isArray(r?.actingPrincipalIds) ? r.actingPrincipalIds : [],
                message: r?.message,
            };
        } catch (e) {
            if (e instanceof ApiError) throw e;
            if (e.statusCode || e.status) throw ApiError.fromResponse(e);
            throw new ApiError(e.message || 'Failed to list incoming delegations', 500, 'UNKNOWN_ERROR', e);
        }
    }
    async create(d) { return this._wrap(() => this.api.create(d), 'Failed to create delegation', 'Vekalet oluşturuldu'); }
    async update(id, d) { return this._wrap(() => this.api.update(id, d), 'Failed to update', 'Vekalet güncellendi'); }
    async delete(id) { return this._wrap(() => this.api.delete(id), 'Failed to delete', 'Vekalet silindi'); }
    async revoke(id) { return this._wrap(() => this.api.revoke(id), 'Failed to revoke delegation', 'Vekalet iptal edildi'); }
    async decline(id) { return this._wrap(() => this.api.decline(id), 'Failed to decline delegation', 'Vekalet reddedildi'); }
    async adminCreate(d) { return this._wrap(() => this.api.adminCreate(d), 'Failed to create delegation', 'Vekalet oluşturuldu'); }

    async _wrap(fn, fb, okMsg) {
        try {
            const r = await fn();
            return { success: true, data: r?.data ?? r, pagination: r?.pagination, message: r?.message || okMsg };
        }
        catch (e) {
            if (e instanceof ApiError) throw e;
            if (e.statusCode || e.status) throw ApiError.fromResponse(e);
            throw new ApiError(e.message || fb, 500, 'UNKNOWN_ERROR', e);
        }
    }
}
